import React from "react";

const IconChat = ({
  width = "20",
  height = "20",
  fill = "#000000",
 className = "",
}) => {
  return (
    <svg
      viewBox="0 0 26 26"
      className={className ? className : null}
      width={width}
      height={height}
      data-name="iconChat"
    >
      <path
        fill={fill}
        d="M24.25 5.5H21.75V16.75H5.5V19.25C5.5 19.9375 6.0625 20.5 6.75 20.5H20.5L25.5 25.5V6.75C25.5 6.0625 24.9375 5.5 24.25 5.5ZM19.25 13V1.75C19.25 1.0625 18.6875 0.5 18 0.5H1.75C1.0625 0.5 0.5 1.0625 0.5 1.75V19.25L5.5 14.25H18C18.6875 14.25 19.25 13.6875 19.25 13Z"
      />
    </svg>
  );
};

export default IconChat;
